import { IEnvironmentService, Value } from './environment.interface';
import { InjectionToken, Optional, Inject, Injectable } from '@angular/core';
import { IEnvironment } from '../../../../environments/environment.interface';

const ENVIRONMENT = new InjectionToken<IEnvironment>('environment');

@Injectable()
class EnvironmentService implements IEnvironmentService {
  private readonly environment: IEnvironment;

  constructor(@Optional() @Inject(ENVIRONMENT) environment: any) {
    this.environment = environment !== null ? environment : {};
  }

  getVars(): IEnvironment {
    return this.environment;
  }

  getVar(key: string): Value {
    const keys = key.split('.');

    return this.getValueByPath(keys);
  }

  private getValueByPath(path: string[], env: object = this.environment): Value {
    const value = env[path[0]];

    if (value) {
      return path.length === 1 ? value : this.getValueByPath(path.slice(1), value);
    }

    return '';
  }
}

export { ENVIRONMENT, EnvironmentService };
